import styled from 'styled-components';
import Button from '@cloudscape-design/components/button';

const ToggleRoleButton = styled(Button)`
    background: transparent;
    color: var(--color-text-button-normal-default-476t5h, #006ce0);
    border-color: transparent;
    border-block-width: 0.5;
    border-inline-width: 0.5;
    position: relative;
    text-decoration: none;
    padding-block: 1;
    padding-inline: 1;
    cursor: pointer;
    &:hover {
      background-color:rgb(222, 217, 210) !important;
  }
 &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

`
export default ToggleRoleButton;